import { render, staticRenderFns } from "./CheckoutView.vue?vue&type=template&id=3225025c&"
import script from "./CheckoutView.vue?vue&type=script&lang=js&"
export * from "./CheckoutView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports